import { createApiActionType } from 'app/store/utils';
import { GET_DEPLOYMENT_OVERVIEW, GET_PROJECT_DEPLOYMENTS } from 'app/lib/types/server';

const apiType = createApiActionType('deployments');

export const GET_DEPLOYMENT_OVERVIEW_ACTION_TYPE = apiType(GET_DEPLOYMENT_OVERVIEW);
export const GET_PROJECT_DEPLOYMENTS_ACTION_TYPE = apiType(GET_PROJECT_DEPLOYMENTS);
